import React, { Component } from 'react';
import { List, ListItem } from 'material-ui/List';
import './App.css';


class ListMenu extends Component {

    state = {
        open: false,
    };

    handleToggle = () => {
        this.setState({
            open: !this.state.open,
        });
    };

    handleNestedListToggle = (item) => {
        this.setState({
            open: item.state.open,
        });
    };

  render() {
    return (
            <div>
                <List>
                    <ListItem
                        primaryText="Competition"
                        initiallyOpen={false}
                        primaryTogglesNestedList={true}
                        nestedItems={[
                            <ListItem
                                key={1}
                                primaryText="Athlete Warrior Fun Meet"
                                primaryTogglesNestedList={true}
                                nestedItems={[
                                    <ListItem value="Bar" primaryText="Bar" onClick={(vidSource, event) => {this.props.setSource("athleteWarrior", 0); this.props.handleClose();}} />,
                                    <ListItem value="Beam" primaryText="Beam" onClick={(vidSource, event) => {this.props.setSource("athleteWarrior", 1); this.props.handleClose();}} />,
                                    <ListItem value="Bar" primaryText="Floor" onClick={(vidSource, event) => {this.props.setSource("athleteWarrior", 2); this.props.handleClose();}} />,
                                    <ListItem value="Beam" primaryText="Vault" onClick={(vidSource, event) => {this.props.setSource("athleteWarrior", 3); this.props.handleClose();}} />,
                                ]}
                            />,
                            <ListItem
                                key={2}
                                primaryText="Motor City Classic"
                                primaryTogglesNestedList={true}

                                nestedItems={[
                                    <ListItem value="Bar" primaryText="Bar" onClick={(vidSource, event) => {this.props.setSource("motorCity", 0); this.props.handleClose();}} />,
                                    <ListItem value="Beam" primaryText="Beam" onClick={(vidSource, event) => {this.props.setSource("motorCity", 1); this.props.handleClose();}} />,
                                    <ListItem value="Bar" primaryText="Floor" onClick={(vidSource, event) => {this.props.setSource("motorCity", 2); this.props.handleClose();}} />,
                                    <ListItem value="Beam" primaryText="Vault" onClick={(vidSource, event) => {this.props.setSource("motorCity", 3); this.props.handleClose();}} />,
                                ]}
                            />,
                            <ListItem
                                key={3}
                                primaryText="Wild Fire Challenge"
                                primaryTogglesNestedList={true}

                                nestedItems={[
                                    <ListItem value="Bar" primaryText="Bar" onClick={(vidSource, event) => {this.props.setSource("wildFire", 0); this.props.handleClose();}} />,
                                    <ListItem value="Beam" primaryText="Beam" onClick={(vidSource, event) => {this.props.setSource("wildFire", 1); this.props.handleClose();}} />,
                                    <ListItem value="Bar" primaryText="Floor" onClick={(vidSource, event) => {this.props.setSource("wildFire", 2); this.props.handleClose();}} />,
                                    <ListItem value="Beam" primaryText="Vault" onClick={(vidSource, event) => {this.props.setSource("wildFire", 3); this.props.handleClose();}} />,
                                ]}
                            />,
                        ]}
                    />
                </List>
            </div>
        );
    }
}

export default ListMenu;


// WEBPACK FOOTER //
// ./src/ListMenu.js